// Shared helpers used by both the AttendanceRecorder (camera audit) and the
// useAttendanceEvents hook (engagement event stream).

export { getCsrfToken } from '../../lib/csrf.js';

// Posts a JSON body using navigator.sendBeacon when available (survives the
// page unload), falling back to fetch+keepalive. Returns true if the dispatch
// was at least queued; the caller can't observe the server response either way.
//
// sendBeacon's body must be a CORS-safelisted Content-Type — JSON isn't, so we
// send the JSON string as text/plain. The server-side intake reads raw_post
// and JSON.parses it itself, so the wire format is unchanged.
export function postBeaconJSON(url, payload) {
  const json = JSON.stringify(payload);
  try {
    const blob = new Blob([json], { type: 'text/plain' });
    if (navigator.sendBeacon && navigator.sendBeacon(url, blob)) return true;
  } catch (_e) { /* fall through */ }
  try {
    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Content-Type': 'text/plain' },
      body: json,
    }).catch(() => {});
    return true;
  } catch (_e) {
    return false;
  }
}
